import { CoSeguimientoPedidoServicio } from './seguimiento/servicio/coseguimientopedidos.service';
import { CoCobranzaServicio } from './cocobranza/service/cocobranza.service';
import { CoAutorizacionDescuentoDetalleService } from './coautorizaciondescuentodetalle/servicio/coautorizaciondescuentodetalle.servicio';
import { NgModule } from '@angular/core';
import { PedidoListadoComponent } from './pedido/vista/pedido-listado.component';
import { CommonModule, LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
//import { GrowlModule } from 'primeng/growl';
import { InputTextModule } from 'primeng/inputtext';
import { BlockUIModule } from 'primeng/blockui';
import { SpinnerModule } from 'primeng/spinner';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { KeyFilterModule } from 'primeng/keyfilter';
//import {  FileUploadModule, InputMaskModule, ColorPickerModule } from 'primeng/primeng';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CoDocumentoCobrarlistadoComponent } from './codocumento/vista/documento_por_cobrar_listado/codocumentocobrar-listado.component';
import { CoDocumentoServicio } from './codocumento/service/codocumento.service';
import { MaMiscelaneosdetalleServicio } from '../core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { PersonamastServicio } from '../core/personamast/service/personamast.service';
import { PersonamastSelectorComponent } from '../core/personamast/vista/selector/personamastselector.component';
import { TipocambiomastServicio } from '../core/tipocambiomast/service/tipocambiomast.service';
import { LabelFromItem } from 'src/app/util/pipes/LabelFromItem.pipe';
import { CoTipoPagoServicio } from './cotipopago/service/cotipopago.service';
import { ParametrosmastServicio } from '../core/parametrosmast/service/parametrosmast.service';
import { CodCotizacionListado } from './cotizacion/vista/cotizacion-listado.component';
import { PedidosSeguimiento } from './seguimiento/vista/pedidos-seguimiento.component';
import { ClienteListadoComponent } from '../core/personamast/vista/listado/cliente-listado.component';
import { CoCotizacionServicio } from './cotizacion/servicio/cotizacion.service';
import { CoPedidosServicio } from './pedido/servicio/copedidos.service';
import { LetralistadoComponent } from './codocumento/vista/letra_listado/letra-listado.component';
import { LineaCreditoComponent } from '../core/clientemast/vista/linea-credito/linea-credito.component';
import { ClientemastServicio } from '../core/clientemast/servicio/clientemast.service';
import { CurrencyMaskModule } from '../../../../node_modules/ng2-currency-mask';
import { GenerarPedidoListadoComponent } from './cotizacion/vista/generarpedido/generarpedido-listado.component';
import { CoVendedorServicio } from './covendedor/servicio/covendedor.service';
import { CanvasComponent } from 'src/app/util/canvas.component';
import { CoCobranzaListado } from './cocobranza/vista/cobranza-listado.component';
import { PedidoMantenimientoNuevoComponent } from './pedido/vista/pedido-mantenimiento-nuevo.component';
import { LogisticaModule } from '../logistica/logistica.module';
import { CoCotizacionMantenimientoNuevoComponent } from './cotizacion/vista/cocotizacion-mantenimiento-nuevo.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { CoDocumentoCobrarNuevolistadoComponent } from './codocumento/vista/documento_por_cobrar_listado/codocumentocobrar-nuevo-listado.component';

@NgModule({
    declarations: [
        PedidoListadoComponent,
        CoDocumentoCobrarlistadoComponent,
        PersonamastSelectorComponent,
        LabelFromItem,
        PedidoListadoComponent,
        CodCotizacionListado,
        PedidosSeguimiento,
        ClienteListadoComponent,
        CodCotizacionListado,
        LetralistadoComponent,
        LineaCreditoComponent,
        GenerarPedidoListadoComponent,
        CanvasComponent,    
        CoCobranzaListado, 
        PedidoMantenimientoNuevoComponent,
        CoCotizacionMantenimientoNuevoComponent,
        CoDocumentoCobrarNuevolistadoComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        LogisticaModule,
        TableModule, PanelModule, 
        //GrowlModule,
        BlockUIModule,
        InputTextModule, ButtonModule, DropdownModule,
        SpinnerModule, CalendarModule, CheckboxModule,
        ConfirmDialogModule, TabViewModule, FieldsetModule,
        KeyFilterModule,
        DialogModule, RadioButtonModule,
        AutoCompleteModule,
        CurrencyMaskModule
    ],
    exports: [

    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        CoDocumentoServicio,
        MaMiscelaneosdetalleServicio,
        PersonamastServicio,
        TipocambiomastServicio,
        DatePipe,
        ConfirmationService,
        LabelFromItem,
        CoTipoPagoServicio,
        ParametrosmastServicio,
        CoCotizacionServicio,
        CoPedidosServicio,
        ClientemastServicio,
        CoVendedorServicio,
        CoCobranzaServicio,
        CoAutorizacionDescuentoDetalleService,
        CoSeguimientoPedidoServicio],
})
export class ComercialModule { }
